import { render, staticRenderFns } from "./base-field-number.vue?vue&type=template&id=406537c8&"
import script from "./base-field-number.vue?vue&type=script&lang=js&"
export * from "./base-field-number.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports